let settings;
let siteColors = [];

const EXPAND_WIDGET_EVENT_NAME = 'TPA_PUB_SUB_ChatWidget.expandWidget';
const ADD_MESSAGE_EVENT_NAME = 'TPA_PUB_SUB_ChatWidget.addMessage';
const COLLAPSE_WIDGET_EVENT_NAME = 'TPA_PUB_SUB_ChatWidget.collapseWidget';
const QUICK_ACTION_TRIGGERED = 'QUICK_ACTION_TRIGGERED';
const ADD_EVENT_LISTENER_EVENT_NAME = 'addEventListener';
const FONT_PARAM_PREFIX = 'param_font_';
const HEADER_FONT_PARAM_NAME = `${FONT_PARAM_PREFIX}header`;
const MESSAGES_FONT_PARAM_NAME = `${FONT_PARAM_PREFIX}messages`;

export const expandWidget = () => expandWidgetImpl();

export const showMobileChat = () => showMobileChatImpl();
const isParameter = (value) => value.includes('color_');
let expandWidgetImpl = () => {};
let showMobileChatImpl = () => {};
let collapseWidgetImpl = () => {};

let initialMessage = '';
let locale = 'en';
let pageTitle = '';
export const setupInitialMessage = (message) => (initialMessage = message);
export const setupLocale = (localeFromHost) =>
  (locale = localeFromHost ? localeFromHost : locale);
export const setupPageTitle = (title) => (pageTitle = title);

export const setSettings = (chatSettings) => {
  settings = chatSettings;
};

export const setSiteColors = (givenSiteColors) => {
  siteColors = givenSiteColors
    .splice(1, givenSiteColors.length - 1)
    .map((color, index) => {
      return { name: `color_${index + 1}`, value: color };
    });
};

const getSafeProperty = (props, object) =>
  props.reduce(
    (nestedObject, prop) =>
      nestedObject && nestedObject[prop] ? nestedObject[prop] : undefined,
    object,
  );

const getColorValue = (colorName) =>
  siteColors.filter((color) => color.name === colorName)[0].value;

const getStyleJson = (color) =>
  color && isParameter(color)
    ? { themeName: color, value: getColorValue(color) }
    : { value: color };

const getFonts = () => ({
  header: getSafeProperty(['userStyles', HEADER_FONT_PARAM_NAME], settings),
  messages: getSafeProperty(['userStyles', MESSAGES_FONT_PARAM_NAME], settings),
});

export const getColorValues = () => {
  const headerTextColor = getSafeProperty(
    ['userStyles', 'param_color_headerTextColor'],
    settings,
  );
  const primaryColor = getSafeProperty(
    ['userStyles', 'param_color_primaryColor'],
    settings,
  );
  const textColor = getSafeProperty(
    ['userStyles', 'param_color_textColor'],
    settings,
  );

  return {
    headerTextColor: getStyleJson(headerTextColor),
    primaryColor: getStyleJson(primaryColor),
    textColor: getStyleJson(textColor),
  };
};
export const messageHandlers = {
  getDemoMode() {
    return true;
  },
  getSiteColors(a, cb) {
    cb(siteColors);
  },
  getStyleParams(a, cb) {
    cb(settings);
  },
  getCompId() {
    return 'comp-id';
  },
  getDeviceType() {
    return 'desktop';
  },
  getInstanceId() {
    return 'some-instance-id';
  },
  getInstanceValue(str) {
    return str === 'aid' ? '1234' : '12';
  },
  getViewMode() {
    return 'standalone';
  },
  getValue(a, cb) {
    cb(settings);
  },
  smCurrentMember(a, cb) {
    return cb(null);
  },
  siteInfo(a, cb) {
    return cb({
      url: 'http://blabla.com',
      pageTitleOnly: pageTitle,
      pageTitle,
    });
  },
  appIsAlive(a, b) {
    b({
      fonts: {
        cssUrls: [
          'https://static.parastorage.com/services/santa-resources/resources/viewer/user-site-fonts/v5/languages.css',
        ],
        imageSpriteUrl:
          'https://static.parastorage.com/services/santa-resources/resources/viewer/editorUI/fonts.v5.png',
        fontsMeta: [],
      },
      siteTextPresets: {},
      siteColors,
      style: {
        colors: getColorValues(),
        numbers: {},
        booleans: {},
        fonts: getFonts(),
        googleFontsCssUrl:
          '//fonts.googleapis.com/css?family=Poppins:n,b,i,bi|Poppins:n,b,i,bi|&subset=hebrew,arabic,latin',
        uploadFontFaces: '',
      },
    });
  },
  getLocale() {
    return locale;
  },
  stylesReady(a, cb) {
    cb();
  },
  getResizedImageUrl(relativeUrl, width, height) {
    return `https://static.wixstatic.com/media/${relativeUrl}/fill/w_${width},h_${height}`;
  },
  resizeWindow(a, cb) {
    document.getElementById('iframe-container').style.height = a.height + 'px';
    document.getElementById('iframe-container').style.width = a.width + 'px';
    return cb(a);
  },
  get(setting, scope, onPublicDataChanged, setDefaultSettings) {
    return setDefaultSettings(setting);
  },
  set() {},
  setFullScreenMobile({ isFullScreen }) {
    const chatElement = document.getElementById('iframe-container');
    if (isFullScreen) {
      chatElement.style.height = '100%';
      chatElement.style.width = '100%';
      chatElement.style.display = 'block';
    } else {
      chatElement.style.display = 'none';
    }
  },
  registerEventListener(eventParams, cb) {
    switch (eventParams.eventKey) {
      case COLLAPSE_WIDGET_EVENT_NAME:
        collapseWidgetImpl = () => {
          cb(
            { eventType: COLLAPSE_WIDGET_EVENT_NAME },
            ADD_EVENT_LISTENER_EVENT_NAME,
          );
        };
        break;
      case EXPAND_WIDGET_EVENT_NAME:
        expandWidgetImpl = () => {
          cb(
            { eventType: EXPAND_WIDGET_EVENT_NAME },
            ADD_EVENT_LISTENER_EVENT_NAME,
          );
        };
        break;
      case ADD_MESSAGE_EVENT_NAME:
        cb(
          {
            eventType: ADD_MESSAGE_EVENT_NAME,
            params: { message: initialMessage },
          },
          ADD_EVENT_LISTENER_EVENT_NAME,
        );
        break;
      case QUICK_ACTION_TRIGGERED:
        showMobileChatImpl = () =>
          cb(
            { eventType: QUICK_ACTION_TRIGGERED, params: {} },
            ADD_EVENT_LISTENER_EVENT_NAME,
          );
        break;
      default:
    }
  },
  onReady(data, callback) {
    return callback();
  },
  getCurrentPageId: (data, cb) => cb('page-id'),
  boundingRectAndOffsets: (data, cb) => {
    cb({
      rect: {
        right: window.innerWidth,
        bottom: window.innerHeight,
      },
    });
  },
};
